import { render, staticRenderFns } from "./EdsAccordionItem.vue?vue&type=template&id=1208dfb6&"
import script from "./EdsAccordionItem.vue?vue&type=script&lang=js&"
export * from "./EdsAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports